/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/

import jwt from "../../http/requests/auth/jwt/index.js";
import router from "@/router";
import store from '@/store/store.js';

// ADD AXIOS IMPORT FOR THE PYTHON BACKEND
import axios from "axios"; 

export default {
  // JWT
  loginJWT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
          .login(payload.userDetails.email, payload.userDetails.password)
          .then(response => {
            console.log("user authentication res", response);
            // If there's user data in response
            if(response) {
              if( response.data) {
                localStorage.setItem("accessToken", response.data[0].name);
                const company_info = {
                  companyId: response.data[0].id,
                  email: response.data[0].email,
                  name: response.data[0].name,
                }
                console.log("company_info", company_info);
                localStorage.setItem('themeColor', response.data[0].themeColor);
                localStorage.setItem('secondaryColor',response.data[0].secondaryColor);
                commit("UPDATE_COMPANY_INFO", company_info, { root: true });
                // Update user details
                // Set bearer token in axios
                commit("SET_BEARER", response.data[0].name);
                resolve(response);
              }
              else{
                localStorage.setItem("accessToken", response.accessToken);
                if(response.user.companyId !== null){
                  console.log("company id is not null",response.user.companyId);
                  store.dispatch("companyManagement/fetchCompany",response.user.companyId).
                  then(res => {
                    console.log("your company details",res.themeColor);
                    window.$cookies.set('companyName', res.data[0].name, Infinity);

                    localStorage.setItem('themeColor',res.themeColor);
                    localStorage.setItem('secondaryColor',res.secondaryColor);
                  })
                }
                const user_info = {
                  usersId: response.user.id,
                  email: response.user.email,
                  userType: response.user.userType,
                  firstName: response.user.firstName,
                  lastName: response.user.lastName,
                  status: response.user.status,
                }
                console.log("user_info", user_info)
                // Update user details
                commit("UPDATE_USER_INFO", user_info, { root: true });
                // Set bearer token in axios
                commit("SET_BEARER", response.accessToken);
                resolve(response);
              }

            }
            else {
              reject({ message: "Wrong Email or Password" });
            }
          })
          .catch(error => {
            console.log(error);
            reject({ message: "Wrong Email or Password" });
          });
    });
  },
  
  // ===================================================================
  // NEW: CONSULTANT LOGIN ACTION (Hitting FastAPI)
  // ===================================================================
  loginConsultant({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // Note: Adjust the URL if your Python backend is on a different port (e.g., http://localhost:8000)
      axios.post('https://parser.ai.getboarded.com/api/consultants/login', {
        email: payload.email,
        password: payload.password,
        remember_me: payload.remember_me
      })
      .then(response => {
        if (response.data.status === 'success') {
          // Save consultant specific tokens (Kept separate from main app tokens)
          localStorage.setItem('consultantToken', response.data.token);
          localStorage.setItem('consultantData', JSON.stringify(response.data.data));
          
          resolve(response.data);
        } else {
          reject({ message: response.data.message || "Login failed" });
        }
      })
      .catch(error => {
        console.error("Consultant Login Error:", error);
        // Extract FastAPI detail error message if it exists
        const errorMsg = error.response && error.response.data && error.response.data.detail 
            ? error.response.data.detail 
            : "Wrong Email or Password";
            
        reject({ message: errorMsg });
      });
    });
  },
  // ===================================================================

  registerUserJWT({ commit }, payload) {
    const {
      id,
      firstName,
      lastName,
      email,
      job_title,
      company,
      password,
      status,
      isVerified
    } = payload.userDetails;
    console.log('paylod data',payload);

    return new Promise((resolve, reject) => {
      jwt
          .registerUser(id, firstName, lastName, email, job_title, company, password,status,isVerified)
          .then(response => {
            console.log("jwt.registerUser Response", response);
            const loginObj = {
              strategy: 'local',
              email,
              password
            }

            store.dispatch("auth/authenticate", loginObj).then(loginRes => {
              // Update data in localStorage
              console.log(loginRes)
              localStorage.setItem('accessToken', loginRes.accessToken)
              commit('UPDATE_USER_INFO', { usersId: response.id, userType: response.userType, email: response.email, status: response.status,isVerified:response.isVerified}, {root: true})
              resolve(loginRes);
            }).catch(logErr => {
              console.log("error user login", logErr)
              reject(logErr)
            });

          })
          .catch(error => {
            reject(error);
          });
    });
  },
  fetchAccessToken() {
    return new Promise(resolve => {
      jwt.refreshToken().then(response => {
        resolve(response);
      });
    });
  }
};